
import {ref} from "vue";
import { useRoute } from 'vue-router';

export default {
  name: "App",
  props:['baseUrl'],
  setup(props:any){
    const route = useRoute();
    // console.log(route.query);
    const validationStatus = ref("Please wait for a second while the requested operation is in progress.............");

    let requestUrl = props.baseUrl + "login/ValidateUserLogin?token="+route.query.token;
    let requestContents={
        method:"GET",
        headers:{
            "Content-Type":"application/json",
        }
    };

    fetch(requestUrl, requestContents)
    .then(response => response.json())
    .then( res => {
        console.log("res " , res);
        if(res.result == null)
        {
            console.log("validation link is expired.");
            validationStatus.value="validation link is corrupted or invalid.";
        }
        else if(res.result.securityOfficerId == 0)
        {
            console.log("validation is already completed or link expired");
            validationStatus.value="validation is already completed or link expired.";
        }  
        else if(res.result.securityOfficerId > 0)
        {
            console.log("validation Process completed successfully.");
            validationStatus.value="validation Process completed successfully. Please log into your account and complete Your profile.";
        }    
        return res;         
        
    });

    return {
        validationStatus,
    }

  },
  
};
